
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 13A6 6 0 107 1a6 6 0 000 12z","stroke":"#EB5757","stroke-width":"1.5","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M6.566 7.868h1.085l.348-4.045H6.208l.358 4.045zm.547 2.545c.519 0 .952-.443.952-.99a.968.968 0 00-.952-.952c-.566 0-1 .443-1 .952 0 .547.434.99 1 .99z","fill":"#EB5757"}})])
          )
        }
      }
    